// extracted by mini-css-extract-plugin
module.exports = {"contained":"overlays-styles-module--contained--3agtF"};